var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "L1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6,
    strokeMiterlimit: 15,
    strokeDasharray: "14.2472,14.2472",
    cx: 50,
    cy: 50,
    r: 47
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "5s",
    from: "0 50 50",
    to: "360 50 50",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeMiterlimit: 10,
    strokeDasharray: "10,10",
    cx: 50,
    cy: 50,
    r: 39
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "5s",
    from: "0 50 50",
    to: "-360 50 50",
    repeatCount: "indefinite"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4CAF50"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 35,
    width: 5,
    height: 30
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "1s",
    type: "translate",
    values: "0 5 ; 0 -5; 0 5",
    repeatCount: "indefinite",
    begin: 0.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 35,
    width: 5,
    height: 30
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "1s",
    type: "translate",
    values: "0 5 ; 0 -5; 0 5",
    repeatCount: "indefinite",
    begin: 0.2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 35,
    width: 5,
    height: 30
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "1s",
    type: "translate",
    values: "0 5 ; 0 -5; 0 5",
    repeatCount: "indefinite",
    begin: 0.3
  })), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 35,
    width: 5,
    height: 30
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "1s",
    type: "translate",
    values: "0 5 ; 0 -5; 0 5",
    repeatCount: "indefinite",
    begin: 0.4
  })), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 35,
    width: 5,
    height: 30
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "1s",
    type: "translate",
    values: "0 5 ; 0 -5; 0 5",
    repeatCount: "indefinite",
    begin: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading1);
export default __webpack_public_path__ + "static/media/loading-1.8a41c3c313531a344188a3aa6760491c.svg";
export { ForwardRef as ReactComponent };